import React from 'react'
import { Text } from '../../../../styles/reactnative'
import PnlPrice from '../../PositionColumns/PnlPrice'
import ReatimePnlPrice from '../../ReatimePnlPrice'
import ReatimePnlPriceSum from '../../ReatimePnlPriceSum'

export const column_group_detail = mutate => {
	return [
		{
			title: '시장코드',
			dataIndex: 'code',
			key: 'code',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시장명(한글)',
			dataIndex: 'name',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시장손익',
			children: [
				{
					title: '평가손익',
					dataIndex: 'pnl',
					align: 'center',
					render: (text, record) => {
						return (
							<ReatimePnlPrice pricelist={record?.infocurrent} dp={0} />
						)
					},
				},
				{
					title: '매매손익',
					dataIndex: 'pnl',
					align: 'center',
					render: (text, record) => {
						return (
							<PnlPrice
								price={
									record?.info?.[0]?.pnl_price -
									Math.abs(record?.info?.[0]?.fee_price)
								}
								krw={true}
								dp={0}
							/>
						)
					},
				},
				{
					title: '수수료',
					dataIndex: 'fee_price',
					align: 'center',
					render: (text, record) => {
						return (
							<PnlPrice
								price={Math.abs(
									-record?.info?.[0]?.fee_price || 0
								)}
								krw={true}
								dp={0}
							/>
						)
					},
				},
				{
					title: '실현손익',
					dataIndex: 'pnl_price',
					align: 'center',
					render: (text, record) => {
						return (
							<PnlPrice
								price={record?.info?.[0]?.pnl_price || 0}
								krw={true}
								dp={0}
							/>
						)
					},
				},
				{
					title: '실시간손익',
					dataIndex: 'real_pnl_price',
					align: 'center',
					render: (text, record) => {
						return (
							<ReatimePnlPriceSum
								pricelist={record?.infocurrent}
								sum={record?.info?.[0]?.pnl_price || 0}
								krw={true}
								dp={0}
							/>
						)
					},
				},
			],
		},
	]
}
